import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface InfestationReport {
  id: string
  name: string
  created_at: string
  status: { label: string; status_key: string }
  requester: { id: string; name: string; email: string }
  report_type: 'infestation'
  company: { id: number; name: string }
  weed_type_by_culture: { cane: string[] | []; soybean: string[] | [] }
  initial_conclusion_date: string
  final_conclusion_date: string
  ordered_by:
    | 'demand_name'
    | '-demand_name'
    | 'created_at'
    | '-created_at'
    | 'infestation_percentage'
    | '-infestation_percentage'
    | 'total_area'
    | '-total_area'
  cultures: string[]
}

export const getInfestationReports = async (
  companyId: number,
  options?: AxiosRequestConfig,
) => {
  const { data } = await companiesApi.get<InfestationReport[]>(
    apiRoutes.getInfestationReports,
    {
      ...options,
      params: {
        idCompany: companyId,
      },
    },
  )

  return data
}
